// @flow

import { type OutgoingPayment } from '../outgoing-payment/types';

export async function boletoOutgoingPaymentMapper(): Promise<$Shape<OutgoingPayment>> {

  return {
    payment_type: 'boleto',
    payment_type_code: 'boleto',
    instalments: '1',
  };
}
